import createIcon from '../../createIcon';

/**
 * @component @name RawOn
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNi4yNTk3NyA5SDIuNzU5NzdWMTVINC4yNTk3N1YxM0g1LjM1OTc3TDYuMjU5NzcgMTVINy43NTk3N0w2Ljg1OTc3IDEyLjlDNy4zNTk3NyAxMi42IDcuNzU5NzcgMTIuMSA3Ljc1OTc3IDExLjVWMTAuNUM3Ljc1OTc3IDkuNyA3LjA1OTc3IDkgNi4yNTk3NyA5Wk02LjI1OTc3IDExLjVINC4yNTk3N1YxMC41SDYuMjU5NzdWMTEuNVoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xMC4wMDk4IDlMOC41MDk3NyAxNUgxMC4wMDk4TDEwLjM4OTggMTMuNUgxMi4xMzk4TDEyLjUwOTggMTVIMTQuMDA5OEwxMi41MDk4IDlIMTAuMDA5OFpNMTAuNzU5OCAxMkwxMS4wMDk4IDExSDExLjUwOThMMTEuNzU5OCAxMkgxMC43NTk4WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTE5LjczOTggOUwxOC45OTk4IDEyTDE4LjI1OTggOUgxNi43Mzk4TDE1Ljk5OTggMTJMMTUuMjU5OCA5SDEzLjc1OThMMTUuMjU5OCAxNUgxNi43Mzk4TDE3LjQ5OTggMTEuOTZMMTguMjU5OCAxNUgxOS43Mzk4TDIxLjIzOTggOUgxOS43Mzk4WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const RawOn = createIcon('RawOn', [
  [
    'path',
    {
      d: 'M6.25977 9H2.75977V15H4.25977V13H5.35977L6.25977 15H7.75977L6.85977 12.9C7.35977 12.6 7.75977 12.1 7.75977 11.5V10.5C7.75977 9.7 7.05977 9 6.25977 9ZM6.25977 11.5H4.25977V10.5H6.25977V11.5Z',
      key: '1st5ul',
    },
  ],
  [
    'path',
    {
      d: 'M10.0098 9L8.50977 15H10.0098L10.3898 13.5H12.1398L12.5098 15H14.0098L12.5098 9H10.0098ZM10.7598 12L11.0098 11H11.5098L11.7598 12H10.7598Z',
      key: 'nruas0',
    },
  ],
  [
    'path',
    {
      d: 'M19.7398 9L18.9998 12L18.2598 9H16.7398L15.9998 12L15.2598 9H13.7598L15.2598 15H16.7398L17.4998 11.96L18.2598 15H19.7398L21.2398 9H19.7398Z',
      key: '1hqwmf',
    },
  ],
]);

export default RawOn;
